import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const UserPrivateRoute = ({ element, roles }) => {
  const users = secureLocalStorage.getItem('user-info');
  if (!users?.role) {
    return <Navigate to="/" replace />;
  }
  if (roles && roles?.includes(users?.role)) {
    return <Outlet />;
  }
  if (roles && !roles?.includes(users?.role)) {
    return <Navigate to="/user/dashboard" replace />;
  }

  return element;
};

export default UserPrivateRoute;
